import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Button, Spinner, Tab, Tabs } from 'react-bootstrap';
import { api_url } from '../../constant/constant';
import { useTranslation } from 'react-i18next';
import { showToast } from '../ShowToast/ToastNotification';

const AddCampaignAssignment = () => {
  const { t, i18n } = useTranslation();
  const { id } = useParams();
  const navigate = useNavigate();

  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState([]);
  const [links, setLinks] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]);
  const [campaignDetails, setCampaignDetails] = useState(null);
  const [campaignType, setCampaignType] = useState(null);

  const fetchCampaignDetails = async () => {
    setIsLoading(true);
    try {
      const token = localStorage.getItem('userToken');
      const response = await fetch(`${api_url}/compliance-campaigns/${id}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.status === 401 || response.status === 403) {
        showToast(t('SessionExpiredPleaseLoginAgain'), 'error');
        localStorage.removeItem('userToken');
        navigate('/login');
        return;
      }

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result = await response.json();
      setCampaignType(result.data.type);
    } catch (error) {
      showToast(t('errorFetchingCampaignDetails'), 'error');
    } finally {
      setIsLoading(false);
    }
  };

  // Fetch data based on campaign type
  const fetchData = async (url = '') => {
    if (!campaignType) return;

    setIsLoading(true);
    try {
      const token = localStorage.getItem('userToken');
      const baseEndpoint =
        campaignType === 'policy' ? `${api_url}/policies` : `${api_url}/surveys`;
      const endpoint = url || baseEndpoint;

      const response = await fetch(endpoint, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result = await response.json();
      setData(result.data.data || []);
      setLinks(result.data.links || []);
    } catch (error) {
      showToast(t('errorFetchingData'), 'error');
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (id) {
      fetchCampaignDetails();
    }
  }, [id]);

  useEffect(() => {
    if (campaignType) {
      fetchData();
    }
  }, [campaignType]);

  const handleChange = (event) => {
    const { options } = event.target;
    const selectedValues = Array.from(options)
      .filter((option) => option.selected)
      .map((option) => ({
        id: option.value,
        type: campaignType,
      }));

    setSelectedItems(selectedValues);
  };

  // const handleAddAssignmen = async (e) => {
  //   e.preventDefault();
  //   setIsLoading(true);

  //   try {
  //     const token = localStorage.getItem('userToken');

  //     // Create an array of assignments to send
  //     const assignments = selectedItems.map(item => ({
  //       campaign_id: id,
  //       assignable_id: item.id,
  //       assignable_type: item.type
  //     }));

  //     const response = await fetch(`${api_url}/compliance-campaigns/campaign-assignments`, {
  //       method: 'POST',
  //       headers: {
  //         'Content-Type': 'application/json',
  //         Authorization: `Bearer ${token}`,
  //       },
  //       body: JSON.stringify(assignments),
  //     });

  //     if (response.ok) {
  //       showToast(t('assignmentsAddedSuccessfully'), 'success');
  //       setSelectedItems([]);
  //       navigate(-1);
  //     } else {
  //       const result = await response.json();
  //       showToast(t(result.message) || result.message, 'error');
  //     }
  //   } catch (error) {
  //     showToast(t('somethingWentWrong'), 'error');
  //   } finally {
  //     setIsLoading(false);
  //   }
  // };

 const handleAddAssignment = async (e) => {
  e.preventDefault();
  setIsLoading(true);
 
  const token = localStorage.getItem('userToken');
 
  if (!token) {
    showToast(t('tokenMissingOrExpired'), 'error');
    setIsLoading(false);
    return;
  }
 
  try {
    for (const item of selectedItems) {
      const payload = {
        campaign_id: id,
        assignable_id: item.id,
        assignable_type: item.type,
      };
 
      const response = await fetch(`${api_url}/compliance-campaigns/campaign-assignments`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(payload),
      });
 
      if (!response.ok) {
        const result = await response.json();
        showToast(t(result.message) || result.message, 'error');
        setIsLoading(false);
        return; // stop on first failure
      }
    }
 
    showToast(t('assignmentsAddedSuccessfully'), 'success');
    setSelectedItems([]);
    navigate('/ComplianceCampaign');
  } catch (error) {
    console.error('Error during assignment:', error);
    showToast(t('somethingWentWrong'), 'error');
  } finally {
    setIsLoading(false);
  }
};
 
 

  return (
    <div
      style={{
        border: '1px solid #EAEAEA',
        borderRadius: '10px',
        padding: '26px',
        margin: '20px',
      }}
    >
      <div className='d-flex justify-content-end mb-3'>
        <Button variant='primary' onClick={() => navigate(-1)}>
          {t('Back')}
        </Button>
      </div>

      <Tabs defaultActiveKey='AddAssignment' className='mb-3'>
        <Tab eventKey='AddAssignment' title={t('AddCampaignAssignment')}>
          <div className='mb-4'>
            <h4>{t('CampaignDetails')}</h4>
          </div>

          <form onSubmit={handleAddAssignment}>
            <div className='mb-3'>
              <label className='form-label'>
                {campaignType === 'policy' ? t('SelectPolicies') : t('SelectSurveys')}
              </label>
              <select
                className='form-control'
                onChange={handleChange}
                multiple
                style={{ height: '220px' }}
              >
                <option value='' disabled>
                  {campaignType === 'policy' ? t('SelectPolicies') : t('SelectSurveys')}
                </option>
                {Array.isArray(data) &&
                  data.map((item) => (
                    <option
                      key={item.id}
                      value={item.id}
                      selected={selectedItems.some((selected) => selected.id === item.id)}
                    >
                      {i18n.language === 'ar' && item.title_ar
                        ? item.title_ar
                        : item.title_en || item.title}
                    </option>
                  ))}
              </select>
            </div>

            <div className='text-end' onClick={handleAddAssignment}>
              <button
              type='submit'
              className='btn btn-primary'
              disabled={isLoading || selectedItems.length === 0}
            >
              {isLoading ? (
                <>
                  <Spinner animation='border' size='sm' role='status' className='me-2' />
                  {t('Adding...')}
                </>
              ) : (
                t('AddAssignment')
              )}
            </button>
            </div>
          </form>

          <div className='navigationWrapper'>
            <ul>
              {links.map((link, index) => (
                <li
                  key={index}
                  className={`${link.active ? ' active ' : ''} ${link.url === null ? ' disabled ' : ''}`}
                  onClick={link.url !== null ? () => fetchData(link.url) : undefined}
                >
                  <div dangerouslySetInnerHTML={{ __html: link.label }} />
                </li>
              ))}
            </ul>
          </div>
        </Tab>
      </Tabs>
    </div>
  );
};

export default AddCampaignAssignment;
